export default __webpack_public_path__ + "static/media/avion.57244f17.jpg";